import React from 'react';
import { NavLink } from 'react-router-dom';
import * as Icons from 'react-icons/vsc';

const DashboardLink = ({ link }) => {
    const Icon = Icons[link.icon];

    return (
        <div>
            <NavLink to={link?.path}>
                <span className='flex items-center gap-x-3'>
                    <Icon />
                    {link?.name}
                </span>
            </NavLink>
        </div>
    );
}

export default DashboardLink;